export const CALCULATION_STRATEGY = {
  weight_based: 'weight_based',
  sku_based: 'sku_based',
} as const
export type CALCULATION_STRATEGY = typeof CALCULATION_STRATEGY[keyof typeof CALCULATION_STRATEGY]

export const FEES = {
  shipping: 'shipping',
} as const
export type FEES = typeof FEES[keyof typeof FEES]

export const DiscountInterval = {
  ONCE_OFF: 'once-off',
  RECURRING: 'recurring',
  HYBRID: 'hybrid',
} as const
export type DiscountInterval = typeof DiscountInterval[keyof typeof DiscountInterval]

export const DiscountScheduleApplicationType = {
  PERCENTAGE: 'percentage',
  DOLLAR: 'dollar',
} as const
export type DiscountScheduleApplicationType = typeof DiscountScheduleApplicationType[keyof typeof DiscountScheduleApplicationType]

export const DiscountScheduleApplicationFilterType = {
  ALL_ITEMS: 'all-items',
  PRODUCT: 'product',
  PRODUCT_VARIANT: 'product-variant',
  PRODUCT_TYPE: 'product-type',
} as const
export type DiscountScheduleApplicationFilterType = typeof DiscountScheduleApplicationFilterType[keyof typeof DiscountScheduleApplicationFilterType]

export const PromotionType = {
  COUPON: 'coupon',
  REFERRAL_COUPON: 'referral-coupon',
  REFERRAL: 'referral',
} as const
export type PromotionType = typeof PromotionType[keyof typeof PromotionType]

export const PromotionUsageContext = {
  PRE_CHECKOUT: 'pre-checkout',
  CHECKOUT: 'checkout',
} as const
export type PromotionUsageContext = typeof PromotionUsageContext[keyof typeof PromotionUsageContext]

export const PromotionUsageType = {
  REFERRAL: 'referral',
  DISCOUNT: 'discount',
} as const
export type PromotionUsageType = typeof PromotionUsageType[keyof typeof PromotionUsageType]

export const PARTNER_DISCOUNTS = {
  '00000002-0000-0000-0000-000000000000': 'Ongoing Partner Discount (25%)',
  '00000002-0000-0000-0000-000000000001': 'Ongoing Partner Discount (50%)',
} as const
export type PartnerDiscountId = keyof typeof PARTNER_DISCOUNTS
